// Valid seller flow overrides
const SELLER_FLOW_OVERRIDES = ['untreated_room_condition'];

export const getInitialSellerFlowName = (sellerInputSellerFlow: string) => {
  const queryParams = new URLSearchParams(window.location.search);
  const sellerFlowOverride = queryParams.get('seller_flow');
  return sellerFlowOverride && SELLER_FLOW_OVERRIDES.includes(sellerFlowOverride)
    ? sellerFlowOverride
    : sellerInputSellerFlow;
};
